export function extractText(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll('emoji').forEach((emojiElem) => {
        const altText = (emojiElem as HTMLElement).getAttribute('alt') ?? '';
        const textNode = document.createTextNode(altText);
        emojiElem.parentNode?.replaceChild(textNode, emojiElem);
    });
    return tempDiv.textContent ?? tempDiv.innerText ?? '';
}
